module.exports = __webpack_public_path__ + "media/images/bredcrumb_arrow-fd93e2d7.png";